import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { conclusioniCoreRules } from './conclusioni-core.rules';
import { conclusioniPropostaGestioneCommRules } from './conclusioni-proposta-gestione-comm.rules';
import { conclusioniPropostaScioglimentoRules } from './conclusioni-proposta-scioglimento.rules';
import { conclusioniPropostaSostLiquidatoreRules } from './conclusioni-proposta-sost-liquidatore.rules';
import { conclusioniPropostaLiquidazioneCoattaRules } from './conclusioni-proposta-liquidazione-coatta.rules';
import { conclusioniAttestatoCrossSectionRules } from './conclusioni-attestato-cross-section.rules';
import { conclusioniAttestatoAmmControlloRules } from './conclusioni-attestato-amm-controllo.rules';
import { conclusioniCkProposteCommRules } from './conclusioni-ck-proposte.rules';

export const ConclusioniRules: FormGroupRules = {
    ...conclusioniCoreRules,
    ...conclusioniPropostaGestioneCommRules,
    ...conclusioniPropostaScioglimentoRules,
    ...conclusioniPropostaSostLiquidatoreRules,
    ...conclusioniPropostaLiquidazioneCoattaRules,
    ...conclusioniAttestatoCrossSectionRules,
    ...conclusioniAttestatoAmmControlloRules,
    ...conclusioniCkProposteCommRules,
};

export const ConclusioniFormValidators = [...Object.values(ConclusioniRules)];
